import { render } from "./commonStatisticsList.vue?vue&type=template&id=424fbff9&scoped=true"
import script from "./commonStatisticsList.vue?vue&type=script&lang=js"
export * from "./commonStatisticsList.vue?vue&type=script&lang=js"

import "./commonStatisticsList.vue?vue&type=style&index=0&id=424fbff9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424fbff9"]])

export default __exports__